import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import MenuHorizontal from "../../layouts/MenuHorizontal";
import { Button, Form, Icon } from "semantic-ui-react";
import CamposCondominio from "./CamposCondominio";
import { CabecalhoForm, RodapeForm } from "../../layouts/FormUI";
import { findById, findByIdAndUpdate, findEnderecoByCep } from "../../../actions/condominio";
import * as FormValidator from "../../../utils/formValidator";
import MenuVertical from '../../layouts/MenuVertical';
import { Redirect, Link } from 'react-router-dom';
import api from '../../../api';

class EditarCondominio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      condominio: {
        nome: "",
        documento: "",
        usarFracaoIdeal: false,
        exibirDocsLinksVotacao: true,
        endereco: {
          cep: "",
          logradouro: "",
          bairro: "",
          cidade: "",
          numero: "",
          uf: "",
          complemento: ""
        }
      },
      errors: {},
      sucesso: false,
      loading: true,
      ruaBairroManual: false,
      enderecoManual: false,
    };
  }

  componentDidMount = async () => {
    try {
      const condominio = await api.condominio.findForEdit(this.props.match.params.id);
      this.setState({ condominio });
    } catch (e) {
      this.setState({ errors: (e.data && e.data.errors) || {} });
    }

    this.setState({
      loading: false,
      ruaBairroManual: false,
      enderecoManual: false,
    });

    if (this.state.condominio && this.state.condominio.endereco.cep) {
      const endereco = await this.props.findEnderecoByCep(this.state.condominio.endereco.cep);
      if (endereco) {
        this.setState({
          enderecoManual: false,
          ruaBairroManual: !endereco.logradouro || !endereco.bairro,
        });
      } else {
        this.setState({ enderecoManual: true });
      }
    }
  };

  onChangeDocumento = e => {
    this.setState({
      condominio: { ...this.state.condominio, [e.target.name]: e.target.value.replace(/\D/g, '') },
      errors: {}
    });
  }

  onChange = e => {
    this.setState({
      condominio: { ...this.state.condominio, [e.target.name]: e.target.value },
      errors: {}, sucesso: false
    });
  };

  onChangeEndereco = async e => {
    const ufSizeValid = e.target.name !== 'uf' || (e.target.name === 'uf' && e.target.value.length <= 2);
    const cepSizeValid = e.target.name !== 'cep' || (e.target.name === 'cep' && e.target.value.length <= 8);

    if (ufSizeValid && cepSizeValid) {
      this.setState({
        condominio: {
          ...this.state.condominio,
          endereco: {
            ...this.state.condominio.endereco,
            [e.target.name]: e.target.value
          }
        },
        errors: {},
        sucesso: false
      });

      if (e.target.name === "cep" && e.target.value && !isNaN(e.target.value) && e.target.value.length === 8) {
        const endereco = await this.props.findEnderecoByCep(e.target.value);
        if (endereco) {
          this.setState({
            condominio: {
              ...this.state.condominio,
              endereco: {
                ...this.state.condominio.endereco,
                logradouro: endereco.logradouro,
                bairro: endereco.bairro,
                cidade: endereco.localidade,
                uf: endereco.uf,
              }
            },
            ruaBairroManual: !endereco.logradouro || !endereco.bairro,
          });
        } else {
          this.setState({
            condominio: {
              ...this.state.condominio,
              endereco: {
                ...this.state.condominio.endereco,
                logradouro: '',
                bairro: '',
                cidade: '',
                numero: '',
                uf: '',
                complemento: '',
              }
            },
            ruaBairroManual: false,
            enderecoManual: true,
          });
        }
      }
    }
  };

  onChangeUsarFracaoIdeal = (e, { name, checked }) => {
    this.setState({
      condominio: { ...this.state.condominio, [name]: checked },
      errors: {},
    });
  };

  onExibirDocsLinksVotacao = (e, { name, checked }) => {
    this.setState({
      condominio: { ...this.state.condominio, [name]: checked },
      errors: {},
    });
  }

  validate = (condominio) => {
    const errors = {};

    if (FormValidator.isVazio(condominio.nome)) {
      errors.nome = "Nome é obrigatório";
    }

    if (FormValidator.isVazio(condominio.documento)) {
      errors.documento = "Documento é obrigatório";
    } else if (!FormValidator.isCpf(condominio.documento) && !FormValidator.isCnpj(condominio.documento)) {
      errors.documento = 'Documento inválido';
    }

    if (!FormValidator.isVazio(condominio.endereco.cep) && !FormValidator.isCep(condominio.endereco.cep)) {
      errors.cep = "CEP inválido";
    }

    return errors;
  };

  onSubmitEditarDados = async (e) => {
    e.preventDefault();
    const errors = this.validate(this.state.condominio);
    this.setState({ errors });
    if (Object.keys(errors).length === 0) {
      this.setState({ loading: true });
      await this.props.findByIdAndUpdate(this.state.condominio._id, { ...this.state.condominio, unidades: [] });
      this.setState({
        loading: false,
        sucesso: (Object.keys(this.props.errors).length === 0),
        errors: this.props.errors
      })
    }
  };

  onToggle = (name, checked) => {
    this.setState({ condominio: { ...this.state.condominio, [name]: checked }, errors: {}, sucesso: false });
  };

  render() {
    const { condominio, errors, loading, loadingCep, sucesso, ruaBairroManual, enderecoManual } = this.state;
    const voltar = `/condominios/${condominio._id}`;
    return (
      <div>
        {!!errors.global && <Redirect to="/" />}
        <MenuHorizontal />
        <div className="corpo-dashboard">
          <MenuVertical condominio={condominio} />
          <div className="va-imp-pagina">
            <CabecalhoForm
              voltar={voltar}
              voltarTexto="Visão geral"
              titulo="Editar condomínio / sociedade / associação"
              descricao="Atualize os dados cadastrais, o endereço e as configurações das votações."
            />
            {sucesso && (
              <div className="va-res-banner sucesso" role="status">
                <Icon name="check circle outline" size="big" />
                <div>
                  <b>Dados alterados com sucesso</b>
                  <div className="va-res-acoes">
                    <Link to={voltar} className="ui button btn-ui-1 small"><Icon name="dashboard" /> Voltar para a visão geral</Link>
                  </div>
                </div>
              </div>
            )}
            <Form onSubmit={this.onSubmitEditarDados} loading={loading} autoComplete="off" className="va-imp">
              <CamposCondominio
                edicao
                condominio={condominio}
                errors={errors}
                loadingCep={loadingCep}
                ruaBairroManual={ruaBairroManual}
                enderecoManual={enderecoManual}
                onChange={this.onChange}
                onChangeDocumento={this.onChangeDocumento}
                onChangeEndereco={this.onChangeEndereco}
                onToggle={this.onToggle}
              />
              <RodapeForm>
                <Button type="submit" loading={loading} disabled={loading} className="btn-ui-1" size="large">
                  <Icon name="save" /> Salvar alterações
                </Button>
                <Link to={voltar} className="ui basic large button">Cancelar</Link>
              </RodapeForm>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    condominio: state.condominio.condominio,
    errors: state.condominio.errors
  }
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    findById,
    findByIdAndUpdate,
    findEnderecoByCep
  }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(EditarCondominio);
